module.exports = __webpack_public_path__ + "img/about_1.be539661.jpg";